import React, { useEffect } from 'react';
import {
  Header, Container, Image,
} from './styled';

function Form({
  style, header, disabled, img, children, onSubmit, ...other
}) {
  let formRef;

  useEffect(() => {
    formRef.onsubmit = onSubmit;
    // const children = $(formRef).children();
    // Array.from(children).forEach((childElement) => {
    // if ($(childElement).css('margin-top') !== '0px') {
    // }
    // });
  }, [formRef, onSubmit]);
  return (
    <Container as={disabled ? 'div' : 'form'} {...other} style={style} ref={ref => (formRef = ref)}>
      {header && <Header>{header}</Header>}
      {img && <Image src={img} />}
      {children}
    </Container>
  );
}
export default Form;
